// extracted by mini-css-extract-plugin
module.exports = {"footerNav":"Footer_footerNav__2NFNF","footerNavgation":"Footer_footerNavgation__3KHyf","footerSocialMedia":"Footer_footerSocialMedia__2176U","copyright":"Footer_copyright__3DGjo"};